<template>
  <v-container fluid>
    <section>
    <data-table
      :headers="headers"
      :items="reportUserSale"
      commit="SET_USER_SALE"
      :viewItem="viewItem"
      :editItem="editItem"
    >
      <div slot="activator" class="row mb-4">
        <v-col cols="2">
          <DatePicker
            :dense="true"
            :placeholder="false"
            label="start_date"
            v-model="start_date"
            hide-details
          />
        </v-col>

        <v-col cols="2">
          <DatePicker
            :dense="true"
            :placeholder="false"
            label="end_date"
            v-model="end_date"
            hide-details
          />
        </v-col>
        <v-col cols="4" offset="2">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </v-col>
      </div>
    </data-table>
    <app-custom-dialog
      width="1000px"
      v-model="dialog"
      :footer="false"
      title="description"
    >
      <div slot="activator">
        <AppDetail :item="form" />
      </div>
    </app-custom-dialog>
    <app-bill v-show="print" :item="form" />
    <!-- AppLoading -->
    <app-loading :overlay="overlay" />
  </section>
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { billReports } from "@/utils/head";
import AppDetail from "@/components/products/billReport";
import { myMixin } from "@/mixin/main";
import AppBill from "@/components/print/bill";
import { error } from "@/controllers/alert";
// get yesterday date
const yesterday = new Date(
  Date.now() - 864e5 - new Date().getTimezoneOffset() * 60000
)
  .toISOString()
  .substr(0, 10);

// get today date
const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
  .toISOString()
  .substr(0, 10);
export default {
  mixins: [myMixin],
  data: () => ({
    start_date: yesterday,
    end_date: today,
    dialog: false,
    print: false,
    overlay: false,
    headers: billReports(),
    form: {},
  }),
  async created() {
    await this.fetchItem(this.start_date, this.end_date);
  },
  components: {
    DataTable,

    AppDetail,
    AppBill,
  },

  computed: {
    ...mapGetters({
      reportUserSale: "index/reportUserSale",
    }),
  },

  watch: {
    start_date(newVal, oldVal) {
      if (oldVal !== undefined && newVal !== oldVal) {
        this.handleDateChange();
      }
    },
    end_date(newVal, oldVal) {
      if (oldVal !== undefined && newVal !== oldVal) {
        this.handleDateChange();
      }
    },
  },

  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async handleDateChange() {
      try {
        await Help.getDifferentMonth(this, this.start_date, this.end_date);
      } catch (err) {
        console.log("error", err.message);
        error(this, err.message);
        return;
      }
      this.overlay = true;
      // setTimeOut for 1 second to show overlay
      setTimeout(() => {
        this.fetchItem(this.start_date, this.end_date);
        this.overlay = false;
      }, 1000);
    },
    async fetchItem(start_date, end_date) {
      const body = {
        that: this,
        url: `user_sale/${this.$route.params.id}?start_date=${start_date}&end_date=${end_date}&q=${this.search}`,
        commit: "SET_USER_SALE",
      };
      await this.fetch(body);
    },

    async viewItem({ id }) {
      this.overlay = true;
      const { data } = await this.$http.get(`bill_detail/${id}`);
      this.form = data.data;
      // setTimeOut for 1 second to show overlay
      setTimeout(() => {
        this.overlay = false;
        this.dialog = !this.dialog;
      }, 1000);
    },

    editItem(item) {
      this.form = item;
      setTimeout(() => {
        this.$htmlToPaper("printBill");
      }, 500);
    },
  },
};
</script>

<style></style>
